var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlways(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 209,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1126 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.865 204.386C81.7544 204.386 50.2134 172.845 50.2134 133.734 50.2134 94.6232 81.7544 63.0821 120.865 63.0821 159.976 63.0821 191.517 94.6232 191.517 133.734L191.517 133.734C191.517 172.845 159.976 204.386 120.865 204.386ZM180.667 72.166 188.237 64.5961C191.013 61.5682 191.013 56.7739 187.985 53.9983 184.957 51.2227 180.415 50.9704 177.387 53.746L168.808 62.5775C156.696 54.503 142.818 49.4564 128.435 48.4471L128.435 37.8493 151.145 37.8493 151.145 22.7096 90.5859 22.7096 90.5859 37.8493 113.296 37.8493 113.296 48.1947C65.8577 52.232 31.0364 94.1185 35.0737 141.304 39.1109 188.489 80.9975 223.563 128.183 219.526 175.368 215.489 210.442 173.602 206.405 126.417 204.638 105.726 195.555 86.5487 180.667 72.166Z",
    transform: "matrix(1 0 0 1.00307 1096.27 239.493)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.761 90.8383C153.668 80.7451 140.295 74.4369 125.912 73.4276L125.912 133.734 115.819 133.734 115.819 73.4276C82.5114 76.2032 57.7832 105.473 60.5588 138.781 63.3345 172.088 92.6046 196.816 125.912 194.293 159.219 191.77 183.947 162.247 181.172 128.94 180.163 114.557 173.854 101.184 163.761 90.8383Z",
    transform: "matrix(1 0 0 1.00307 1096.27 239.493)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlways);
export default __webpack_public_path__ + "static/media/always.f43bc175d030d5f39aff7b3de9003447.svg";
export { ForwardRef as ReactComponent };